(function (window) {
  'use strict';

  function safeGetCookie(name) {
    if (!name) return null;

    const nameEq = String(name) + '=';
    const decodedCookie = document.cookie || '';
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEq) === 0) {
        return decodeURIComponent(c.substring(nameEq.length, c.length));
      }
    }

    return null;
  }

  function safeSetCookie(name, value, days) {
    if (!name) return;

    const expires =
      typeof days === 'number'
        ? (function () {
            const d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            return '; expires=' + d.toUTCString();
          }())
        : '';

    // Keep path=/ to match theme cookie behavior.
    document.cookie = String(name) + '=' + (value || '') + expires + '; path=/';
  }

  function safeEraseCookie(name) {
    if (!name) return;
    document.cookie = String(name) + '=; Max-Age=-99999999; path=/';
  }

  function ensureCookieGlobals() {
    // Injected inline scripts expect global cookie helpers.
    if (typeof window.getCookie !== 'function') {
      window.getCookie = safeGetCookie;
    }

    if (typeof window.setCookie !== 'function') {
      window.setCookie = safeSetCookie;
    }

    if (typeof window.eraseCookie !== 'function') {
      window.eraseCookie = safeEraseCookie;
    }
  }

  ensureCookieGlobals();

  function setPendingState(popupEl) {
    if (!popupEl) return false;

    popupEl.classList.add('is-minicart-product-pending');

    return true;
  }

  function unwrapMainContent(html) {
    if (!html || html.indexOf('MainContent') === -1) return html;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const main = doc.getElementById('MainContent');
    return main ? main.innerHTML : html;
  }

  function runInlineScripts(container) {
    if (!container) return;

    ensureCookieGlobals();

    container.querySelectorAll('script').forEach(function (oldScript) {
      if (oldScript.src) return;

      // Only re-create scripts that are meant to be executed as JavaScript.
      // JSON-LD and other non-JS script types must be left intact, otherwise the browser will
      // attempt to parse JSON as JS and throw syntax errors (e.g. unexpected `:`).
      const scriptType = (oldScript.type || '').trim().toLowerCase();
      const isJavaScript =
        !scriptType ||
        scriptType === 'text/javascript' ||
        scriptType === 'application/javascript' ||
        scriptType === 'module';

      if (!isJavaScript) return;

      const script = document.createElement('script');

      // Preserve attributes (e.g. type, data-*, nonce, etc.).
      if (oldScript.attributes && oldScript.attributes.length) {
        for (let i = 0; i < oldScript.attributes.length; i += 1) {
          const attr = oldScript.attributes[i];
          script.setAttribute(attr.name, attr.value);
        }
      }

      script.text = oldScript.textContent;
      if (oldScript.parentNode) oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function injectMinicartHtml(popupEl, htmlString) {
    if (!popupEl || !htmlString) return false;

    popupEl.innerHTML = unwrapMainContent(htmlString);
    runInlineScripts(popupEl);
    popupEl.classList.remove('is-minicart-product-pending');

    return true;
  }

  window.CuracaoMiniCartInject = {
    setPendingState: setPendingState,
    injectMinicartHtml: injectMinicartHtml
  };
}(window));
